import { useLocation, useOutletContext, useSearchParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { Features } from 'generated/featureDefinitions'
import { isUndefined } from 'lodash'
import omitBy from 'lodash/omitBy'

import { useFeatureAvailability } from 'modules/core/hooks/useFeatureAvailability'
import { useUnsafeMemo } from 'modules/core/hooks/useMemo'
import { trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import ReportsEditor from 'modules/reports/components/Editor'
import type { RouteContextParams } from 'modules/reports/lib/RouterContextParams'
import Report from 'modules/reports/store/models/Report'

import SaveModal, { SAVE_ACTION } from '../components/SaveReportModal'
import { useReportTracking } from '../hooks/useReportTracking'
import { useStoreSafe } from '../hooks/useStore'
import { PromptProvider } from '../lib/promptContext'

const NewReportPage = () => {
  const location = useLocation()
  const [search, _] = useSearchParams()
  const showSaveModal = search.get('action') == SAVE_ACTION
  const { dashboard, loading } = useOutletContext<RouteContextParams>()
  const chart_type = new URLSearchParams(location.search).get('chart_type')
  const { loading: isFeatureLoading, featureAvailability } = useFeatureAvailability(
    Features.analytics_advanced_reports
  )

  const report = useUnsafeMemo<Report>(() => {
    return new Report(omitBy({ dashboard_id: dashboard?.id, chart_type }, isUndefined))
  }, [dashboard, chart_type])

  const store = useStoreSafe({
    report,
    origin: 'builder',
  })
  const { track } = useReportTracking(store)

  const onSuccess = () => {
    track(trackingEvents.reports.submitReportFromGenerator)
    track(trackingEvents.reports.newReportSaved)
  }

  const isAuthorized = featureAvailability.available

  return (
    <ResponsivePage.Body
      variant="full"
      authorized={isAuthorized}
      error={undefined}
      loading={loading || isFeatureLoading}
      showHeader={false}
    >
      <PromptProvider>
        {showSaveModal && report && store && <SaveModal report={report} store={store} />}
        <Box flexDirection="column">
          <Box>{store && <ReportsEditor store={store} />}</Box>
        </Box>
      </PromptProvider>
    </ResponsivePage.Body>
  )
}

export default NewReportPage
